import axios from "axios";

// Production can use a same-origin /api Worker; set REACT_APP_BACKEND_URL only when using a separate API host.
// Single API origin: the Worker that already serves /plant-status and /auth.
// Same-origin /api on www.kashyapgreenfuels.com returns 404 {"error":"Not found"}.
const WORKER_ORIGIN = "https://kgf-api.om700500.workers.dev";
export const API = `${(process.env.REACT_APP_BACKEND_URL || WORKER_ORIGIN).replace(/\/$/, "")}/api`;
export const KGF_API = API;
export const AUTH_API = "https://kgf-api.om700500.workers.dev/api";
export const TOKEN_KEY = "kgf_admin_token";

export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY) || ""}` });

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const PRODUCT_IMAGES = {
  "huskfire-6": "/images/pellets-6mm.jpg",
  "huskfire-8": "/images/pellets-8mm.jpg",
  strawblock: "/images/briquettes.jpg",
};

export const productImage = (slug) => PRODUCT_IMAGES[slug] || "/images/hero-pellets.jpg";

export const CONTACT = {
  email: "info@kashyapgreenfuels.com",
};

export default axios;
